import { render } from "./PageLinks.vue?vue&type=template&id=269392d2"
import script from "./PageLinks.vue?vue&type=script&lang=js"
export * from "./PageLinks.vue?vue&type=script&lang=js"
script.render = render

export default script